
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('rect',{staticClass:"cls-1",attrs:{"x":"30.33","y":"62.81","width":"75.73","height":"61.17","rx":"16.18"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M46.88 131.74h62.58q.67 0 1.32-.06a17 17 0 0015.68-16.92V71.07a17 17 0 00-17-17H40.54a17 17 0 00-17 17v43.69a17 17 0 0016.63 17M60.55 54.07a9.22 9.22 0 0118.2 0"}}),_c('circle',{staticClass:"cls-2",attrs:{"cx":"116.62","cy":"88.71","r":"3.01"}}),_c('circle',{staticClass:"cls-2",attrs:{"cx":"116.62","cy":"98.07","r":"3.01"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M110.78 131.68l1.89 3.29a2.51 2.51 0 01-.92 3.44l-.68.39a2.5 2.5 0 01-3.44-.93l-3.54-6.13M46.88 131.74l-3.54 6.13a2.51 2.51 0 01-3.44.93l-.68-.39a2.51 2.51 0 01-.92-3.41l1.87-3.23zM83.25 14.74l-9.71 32.05M59.94 32.22l6.8 14.57"}}),_c('circle',{staticClass:"cls-2",attrs:{"cx":"83.98","cy":"13.53","r":"2.67"}}),_c('circle',{staticClass:"cls-2",attrs:{"cx":"59.7","cy":"31.98","r":"2.67"}})])
          )
        }
      }
    